import styled from 'styled-components'

export const FormFieldInput = styled.input`
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  font-weight: 400;
  outline: none;
  -webkit-font-smoothing: antialiased;
  color: ${({ theme }) => theme.colors.primary};

  border: ${({ theme }) => `1px solid ${theme.colors.backgroundLite}`};

  background-color: ${({ disabled, theme }) => (disabled ? 'transparent;' : theme.colors.backgroundLite)};

  &::placeholder {
    color: ${({ theme }) => theme.colors.primary};
  }
`
